// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const SubProductFinanceAssetService = {};
 

SubProductFinanceAssetService.postSubProductFinanceAsset = function (data) {
  return lossClient({
    url: "/subproductfinanceasset/add",
    method: "post",
    data: data,
  });
};

SubProductFinanceAssetService.getSubProductFinanceAssetList = function (
  userInput
) {
  var userInputIndex = userInput.pageIndex || 0;
 
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // console.log(
  //   "🚀 ~ file: SubProductFinanceAssetService.js:22 ~ decrementIndex:",
  //   decrementIndex
  // );
  return lossClient({
    url:
      "/subproductfinanceasset/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

SubProductFinanceAssetService.getSubProductFinanceAssetApprovalList = function (
  userInput
) {
  var userInputIndex = userInput.pageIndex;
 
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  
  return lossClient({
    url:
      "/subproductfinanceasset/approvalItems?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

SubProductFinanceAssetService.putSubProductFinanceAssetApproval = function (
  data
) {
  const requestDataValidation =
    data.approvalFlag.toLowerCase() == "return"
      ? {
          Note: data.note,
          UserId: data.userId,
          FinanceAssetId: data.FinanceAssetId,
        }
      : data.approvalFlag.toLowerCase() == "reject"
      ? {
          SubProductFinanceAssets: [
            {
              AssetId: data.AssetId,
            },
          ],
          UserId: data.userId,
          Note: data.note,
        }
      : data.approvalFlag == "approve"
      ? {
          Note: data.note,
          UserId: data.userId,
          FinanceAssetId: data.FinanceAssetId,
        }
      : {
          Note: data.note,
          UserId: data.userId,
          FinanceAssetId: data.FinanceAssetId,
        };

  let urlRequest;
  const requestUrlValdiation =
    data.approvalFlag.toLowerCase() == "return"
      ? (urlRequest = "return")
      : data.approvalFlag.toLowerCase() == "reject"
      ? (urlRequest = "reject")
      : data.approvalFlag == "approve"
      ? (urlRequest = "Approve")
      : (urlRequest = "");

  // console.log("🚀 ~ data:", data);
  // console.log("🚀 ~ urlRequest:", urlRequest);
  // console.log("🚀 ~ requestUrlValdiation:", requestUrlValdiation);
  // console.log("🚀 ~ validData:", requestDataValidation);

  return lossClient({
    url: `/SubproductFinanceAsset/${urlRequest}`,
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: requestDataValidation,
  });
};

SubProductFinanceAssetService.putSubProductFinanceAssetRequest = function (
  data
) {
  // console.log("🚀 ~ data:", data);
  // var bodyRequest = {
  //   // SubProductFinanceAssets: [{ AssetId: data.AssetId }],
  //   Request: data.request,
  //   note: data.note,
  //   userId: data.userId,
  // };
  var bodyRequest = {
    Request: data.request,
    note: data.note,
    userId: data.userId,
    FinanceAssetId: data.FinanceAssetId,
  };
  // console.log("🚀 ~ bodyRequest:", bodyRequest);
  return lossClient({
    url: `/SubproductFinanceAsset/${data.approvalFlag}`,
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: bodyRequest,
  });
};

SubProductFinanceAssetService.getSubProductFinanceAssetDetail = function (
  data
) {
  return lossClient({
    url: `/SubProductFinanceAssetType/${data.id}`,
    method: "get",
  });
};

SubProductFinanceAssetService.updateSubProductFinanceAsset = function (data) {
  // console.log("🚀 ~ data:", data);
  const { id, UserId, ...requestBody } = data;
  // console.log("🚀 ~ rest:", requestBody);
  // const requestBody = {
  //   TypeofUse: data.TypeOfUse,
  //   Description: data.description,
  //   userid: data.userid,
  // };
  return lossClient({
    url: "/SubproductFinanceAsset/Edit",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: requestBody,
  });
};

SubProductFinanceAssetService.deleteSubProductFinanceAsset = function (data) {
 
  
  const { id, ...requestBody } = data;
  // console.log("🚀 ~ requestBody:", requestBody);
  return lossClient({
    url: "/SubproductFinanceAsset/Delete",
    method: "delete",
    headers: {
      "x-requestid": data.id,
    },
    data: requestBody,
  });
};

export default SubProductFinanceAssetService;
